import { useEffect, useState } from 'react'
import { company, customerData } from '../../../utilities/CustomerData'

export function AdvancePaymentDetails({ interestAmount, lienAmount, step, setStep, _setLoanInterestAmount }) {
  const [agree, setAgree] = useState(false)
  const [creditAmount, setCreditAmount] = useState(0)
  const [loanInterest, setLoanInterest] = useState(0)

  useEffect(() => {
    window.scrollTo(0,0)
    setCreditAmount((customerData.customerLeadData.leadAmount - lienAmount))
  }, [])

  useEffect(() => {
    if(creditAmount > 0) {
      const loanInterest = .5999*70/365*creditAmount
      setLoanInterest(interestAmount < loanInterest ? interestAmount : loanInterest)
      _setLoanInterestAmount(interestAmount < loanInterest ? interestAmount : loanInterest)
    }
  }, [creditAmount])

  useEffect(() => {
    document.title = `${company.companyName} | Refund Details`
  }, [])

  return (
    <div className='w-full flex flex-col items-center'>
      <div className='lg:max-w-screen-lg w-11/12 flex flex-col items-center gap-2 lg:p-10'>
        <p className='text-2xl font-bold'>Advanced Payment Fees and Disbursements</p>
        <p>This advance will be paid out to you in <span className='font-bold'>two seperate payouts</span> according to the details and fees outlined below.</p>
        <div className='w-full flex flex-col'>
          <p className='font-bold'>Payable to you:</p>
          <div className='flex lg:flex-row flex-col gap-4 items-stretch'>
            <div className='flex flex-col flex-1 p-4 rounded-md shadow-md bg-gray-50'>
              <div className='flex flex-row justify-between'>
                <p className='font-bold'>1st payout</p>
                <p className='font-bold p-2 rounded-full bg-gray-100 text-xs'>3-5 days</p>
              </div>
              <p>Paid to you in about 3-5 days. No waiting for IRS processing</p>
              <div className='flex flex-row items-center justify-between rounded-lg bg-gray-100 p-2 mt-auto'>
                <p className='font-bold'>${((customerData.customerLeadData.leadAmount - lienAmount) - ((customerData.customerLeadData.leadAmount - lienAmount) * 0.29)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
              </div>
            </div>
            <div className='flex flex-col flex-1 p-4 rounded-md shadow-md bg-gray-50'>
              <div className='flex flex-row justify-between'>
                <p className='font-bold'>2nd payout</p>
                <p className='font-bold p-2 rounded-full bg-gray-100 text-xs'>2-5 months</p>
              </div>
              <p>Paid to you upon receipt of your IRS refund</p>
              <div className='flex flex-row items-center justify-between rounded-lg bg-gray-100 p-2 mt-auto'>
                <p className='font-bold'>Remainder of IRS Interest</p>
              </div>
            </div>
          </div>
        </div>
        <div className='w-full flex flex-col gap-2'>
          <div onClick={() => setAgree(!agree)} className='bg-gray-100 rounded-lg p-4 flex flex-row gap-2 cursor-pointer'>
            <input
              type='checkbox'
              id='checkbox1'
              checked={agree}
              onChange={(e) => setAgree(e.target.checked)}
              className='mr-2'
            />
            <p>I agree to the pricing and fee schedule for the Refund Advance Loan</p>
          </div>
          <div className='w-full flex flex-row items-center gap-2'>
            <button onClick={() => setStep(step - 2)} className='w-1/2 bg-gray-200 rounded-lg p-2'>
              Back
            </button>
            <button disabled={!agree} onClick={() => setStep(step + 1)} className={`w-1/2 rounded-lg p-2 text-white ${agree ? 'bg-primaryColor hover:bg-primaryDarkColor transition duration-200' : 'bg-gray-400 cursor-not-allowed'}`}>
              Continue
            </button>
          </div>
        </div>
        <div className='w-full border-b-2 border-gray-200 m-8'></div>
        <div className='w-full flex flex-col gap-20'>
          <div className='w-full flex flex-col'>
            <p className='font-bold text-gray-500'>Payment 1 Breakdown</p>
            <div className='overflow-x-auto'>
              <table className='w-full border-collapse border border-gray-300 mt-4'>
                <thead>
                  <tr className='bg-gray-100'>
                    <th className='border border-gray-300 px-4 py-2 text-left'>Fee</th>
                    <th className='border border-gray-300 px-4 py-2 text-left'>Amount</th>
                    <th className='border border-gray-300 px-4 py-2 text-left'>Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className='border border-gray-300 px-4 py-2'>Initial Tax Credit Amount</td>
                    <td className='border border-gray-300 px-4 py-2 text-green-500 text-nowrap text-center'>${customerData.customerLeadData.leadAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    <td className='border border-gray-300 px-4 py-2'>Your current calculated tax credit</td>
                  </tr>
                  <tr>
                    <td className='border border-gray-300 px-4 py-2'>Tax Liability</td>
                    <td className='border border-gray-300 px-4 py-2 text-red-500 text-nowrap text-center'>-${lienAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    <td className='border border-gray-300 px-4 py-2'>Amount you owe to the IRS</td>
                  </tr>
                  <tr>
                    <td className='border-4 border-gray-300 px-4 py-2 font-bold'>Initial Tax Credit Loan Amount</td>
                    <td className='border-4 border-gray-300 px-4 py-2 text-green-500 text-nowrap text-center font-bold'>${creditAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    <td className='border-4 border-gray-300 px-4 py-2 font-bold'>Your current tax credit loan amount</td>
                  </tr>
                  <tr>
                    <td className='border border-gray-300 px-4 py-2'>Processing Fee</td>
                    <td className='border border-gray-300 px-4 py-2 text-red-500 text-nowrap text-center'>-${(creditAmount * 0.2).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    <td className='border border-gray-300 px-4 py-2'>Paid from the advanced funds</td>
                  </tr>
                  <tr>
                    <td className='border border-gray-300 px-4 py-2'>Fraud, Compliance, and Verification Fee (3rd Party)</td>
                    <td className='border border-gray-300 px-4 py-2 text-red-500 text-nowrap text-center'>-${(creditAmount * 0.09).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    <td className='border border-gray-300 px-4 py-2'>Paid to Phoenix on your behalf from the advance funds</td>
                  </tr>
                  <tr>
                    <td className='border border-gray-300 px-4 py-2'>Payout 1: Total disbursed to you within 3 to 5 days</td>
                    <td className='border border-gray-300 px-8 py-2 text-green-500 text-nowrap'>+${(creditAmount - (creditAmount * 0.29)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    <td className='border border-gray-300 px-4 py-2'>These funds will be depositied into your connected bank account in an average of 3 to 5 days after we submit your amended return to the IRS.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className='flex flex-col'>
            <p className='font-bold text-gray-500'>Payment 2 Breakdown</p>
            <div className='overflow-x-auto'>
              <table className='w-full border-collapse border border-gray-300 mt-4'>
                <thead>
                  <tr className='bg-gray-100'>
                    <th className='border border-gray-300 px-4 py-2 text-left'>Fee</th>
                    <th className='border border-gray-300 px-4 py-2 text-left'>ESTIMATED Amount</th>
                    <th className='border border-gray-300 px-4 py-2 text-left'>Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className='border border-gray-300 px-4 py-2'>Interest the IRS owes you for this 2021 tax credit</td>
                    <td className='border border-gray-300 px-4 py-2 text-green-500 text-nowrap text-center'>${interestAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}<br />(ESTIMATE ONLY)</td>
                    <td className='border border-gray-300 px-4 py-2'>The IRS pays interest on overpayments. The exact amount of this interest owed to you by the IRS will vary based on the timing of your submission, their refund, and any offset you may owe.</td>
                  </tr>
                  <tr>
                    <td className='border border-gray-300 px-4 py-2'>Loan interest owed to bank</td>
                    <td className='border border-gray-300 px-4 py-2 text-red-500 text-nowrap text-center'>-${loanInterest.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}*<br />(ESTIMATE ONLY)</td>
                    <td className='border border-gray-300 px-4 py-2'>Interest will accrue on your total tax credit loan amount at 59.99%. This accrued interest will be taken out of and paid by the interest the IRS will refund to you. You will never owe the bank more than your tax credit amount plus interest paid to you by the IRS from your tax credit. * Interest estimate based upon an estimated 70 days of interest.</td>
                  </tr>
                  <tr>
                    <td className='border border-gray-300 px-4 py-2'>Payout 2:<br />Total disbursed to you after your refund check is received by the bank and processed to pay back your loan.</td>
                    <td className='border border-gray-300 px-4 py-2 text-green-700 text-nowrap text-center font-bold bg-[#74be43]'>+${(interestAmount - loanInterest).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}<br />(ESTIMATE ONLY)</td>
                    <td className='border border-gray-300 px-4 py-2'>The remaining interest paid to you by the IRS after removing the accrued interest owed to the Bank will be refunded to you and deposited into your bank account.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <p className='italic text-gray-400 max-sm:mb-10'>Loan Products are provided by Community Bank & Trust - WGA, an Equal Housing Lender, Member FDIC.</p>
        </div>
      </div>
    </div>
  )
}